module.exports = __webpack_public_path__ + "assets/9ffa3b7e0e4015de0645a28d621e0312.png";